import React from 'react';
import { Card } from "react-bootstrap";
import styles from '../SessionHistoryDetailView.module.css';

const PresentingConcernsSection = ({
  sessionFormData,
  updateFormData,
  handleConcernChange,
  checkboxError,
  autoResizeTextarea
}) => {
  const concernOptions = [
    "Anxiety",
    "Depression",
    "Trauma / PTSD",
    "Stress",
    "Grief / Loss",
    "Anger",
    "Relationship Issues",
    "Self-Esteem / Confidence",
    "Other",
    "Work Stress / Burnout",
    "Life Transitions",
    "Substance Use",
    "Sleep Issues",
    "Concentration",
    "Behavioral Issues",
    "Emotional Regulation",
    "Adjustment Difficulties",
  ];

  const leftColumnItems = concernOptions.slice(0, Math.ceil(concernOptions.length / 2));
  const rightColumnItems = concernOptions.slice(Math.ceil(concernOptions.length / 2));

  return (
    <Card id="presenting-concerns" className={styles.card}>
      <h3 className={styles.sectionHeading}>
        Presenting Concerns
      </h3>
      <div style={{ marginBottom: "24px" }}>
        <label className={styles.labelWithMargin}>
          Reason for seeking services:
        </label>
        <textarea
          value={sessionFormData.reasonForSeekingServices}
          onChange={(e) => updateFormData("reasonForSeekingServices", e.target.value)}
          placeholder="Free-text"
          className={styles.textarea}
        />
      </div>
      <div>
        <label className={styles.labelWithMarginLarge}>
          Check all that apply:
        </label>
        {checkboxError && (
          <div className={styles.errorMessage}>
            {checkboxError}
          </div>
        )}
        <div className={styles.checkboxRow}>
          <div className={styles.checkboxColumn}>
            {leftColumnItems.map((item) => (
              <div key={item} className={styles.checkboxContainer}>
                <input
                  type="checkbox"
                  id={`concern-${item}`}
                  checked={sessionFormData.selectedConcerns.includes(item)}
                  onChange={() => handleConcernChange(item)}
                  className={styles.checkbox}
                />
                <label htmlFor={`concern-${item}`} className={styles.checkboxLabel}>
                  {item}
                </label>
              </div>
            ))}
          </div>
          {/* Right Column */}
          <div className={styles.checkboxColumn}>
            {rightColumnItems.map((item) => (
              <div key={item} className={styles.checkboxContainer}>
                <input
                  type="checkbox"
                  id={`concern-${item}`}
                  checked={sessionFormData.selectedConcerns.includes(item)}
                  onChange={() => handleConcernChange(item)}
                  className={styles.checkbox}
                />
                <label htmlFor={`concern-${item}`} className={styles.checkboxLabel}>
                  {item}
                </label>
              </div>
            ))}
          </div>
        </div>
        {sessionFormData.selectedConcerns.includes("Other") && (
          <div style={{ marginTop: "12px" }}>
            <textarea
              id="concern-other-textarea"
              value={sessionFormData.otherConcernText || ""}
              onChange={(e) => {
                autoResizeTextarea(e.target);
                updateFormData("otherConcernText", e.target.value);
              }}
              placeholder="Please specify."
              className={styles.otherTextInput}
              rows={1}
              style={{ minHeight: "34px", resize: "none", overflow: "hidden" }}
            />
          </div>
        )}
      </div>
    </Card>
  );
};

export default PresentingConcernsSection;

